import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BulletinBoardFormModel } from './bulletin-board.form-model';
import { IBBSearchParams } from './bulletin-board.interface';
import { PrimaryLayoutService } from '../../core/layout/primary-layout/primary-layout.service';

@Injectable({
  providedIn: 'root',
})
export class ProductRequestSearchUseCase {
  readonly #router = inject(Router);
  readonly #primaryLayoutService = inject(PrimaryLayoutService);
  readonly formModel = new BulletinBoardFormModel();

  async searchProductRequests(params?: Partial<IBBSearchParams>) {
    const navigated = await this.#router.navigate(['/'], { queryParams: params });
    if (navigated) {
      // PrimaryLayoutServiceのscrollToを使用する
      this.#primaryLayoutService.scrollTo({ top: 0, behavior: 'instant' });
    }
  }
}
